import { ITEMS_RARITY, ItemTemplate } from "../constants";

export default {
    type: "vip_items",
    listData: [{
        "key": "name",
        "label": "Name",
    }, {
        "key": "rarity",
        "label": "Rarity",
    }, {
        "key": "price",
        "label": "Price",
    }, {
        "key": "vip_points",
        "label": "VIP points",
    }],
    template: [{
        "key": "name",
        "label": "Name",
        "type": "input",
    }, {
        "key": "game_id",
        "label": "Game Id",
        "type": "input",
        "format": "integer"
    }, {
        "key": "price",
        "label": "Price",
        "type": "input",
        "format": "integer"
    }, {
        "key": "vip_points",
        "label": "VIP points",
        "type": "input",
        "format": "integer",
        "disabled": true,
    }, {
        "key": "rarity",
        "label": "Rarity",
        "type": "select",
        "values": ITEMS_RARITY
    }]
} as ItemTemplate;
